import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const m = a((e, r) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: r,
    ...e,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4130",
              width: 32,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M12.45 19.62c4.7 1.3 11.45 1.33 11.55 1.33 14.89 0 16-.8 16-2.02 0-.2-.06-.48-.32-.75-.99-.98-5.17-1.13-13.6-1.09-.75 0-1.45.01-2.08.01-5.11 0-8.91.31-11.52.97-1.84-.55-2.97-1.19-2.97-1.84 0-.71.97-1.35 2.66-1.86 3.96 1.05 9.72 1.33 11.83 1.33h2.1c8.45.03 12.54-.08 13.56-1.1.28-.28.34-.58.34-.78 0-.89 0-2.23-16-2.23-2.92 0-8.19.17-11.88 1.24-1.48-.41-2.4-.84-2.51-1.2.33-.87 5.78-2.13 14.79-2.13 6.22 0 10.77.51 14.75 1.05.4.06.79-.23.84-.64a.74.74 0 0 0-.64-.84C35.31 8.51 30.7 8 24.4 8c-3.82 0-16.29.26-16.29 3.6 0 .83.74 1.49 1.91 2.03-1.24.65-2.02 1.49-2.02 2.6 0 1.1.89 1.95 2.25 2.6-1.51.74-2.24 1.72-2.24 2.96 0 1.19 1 2.11 2.63 2.81C8.99 25.74 8 27.45 8 30v9.25c0 .41.34.75.75.75s.75-.34.75-.75V30c0-2.28.85-3.81 3-4.77 3.09.84 7.37 1.19 11.5 1.19 16 0 16-1.16 16-2.19 0-.19-.06-.48-.32-.74-1-.99-5.28-1.15-14.45-1.15H24c-4.38 0-8.53.16-11.5 1.3-2.05-.62-2.98-1.34-2.98-1.85 0-.63.53-1.5 2.93-2.17M24 18.59c.63 0 1.33 0 2.08-.01 3.05-.01 8.78-.04 11.34.33-1.66.27-5.35.53-13.43.53-2.61 0-5.2-.2-7.45-.54 1.94-.19 4.38-.31 7.46-.31m0-5.5c8.03 0 12.03.38 13.7.74-2.24.4-7.73.39-11.59.38L24 14.2c-2.96 0-5.78-.25-8.12-.6 2.29-.33 5.06-.51 8.12-.51m0 10.75h1.23c3.64 0 9.88-.01 12.4.42-1.47.3-5.03.66-13.63.66-3.43 0-6.18-.23-8.33-.57 2.11-.35 4.84-.51 8.33-.51"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4130)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-.287-1.587h49.66v49.66H-.287z" }) })
        ]
      }
    )
  }
));
m.displayName = "AgencyFirmnessIcon";
export {
  m as AgencyFirmnessIcon,
  m as default
};
//# sourceMappingURL=index.js.map
